export const environment = {
  production: true,
  oktaBaseUrl: 'https://gsa.okta.com',
  oktaIssuer: 'https://gsa.okta.com/oauth2/default',
  oktaRedirectUri: 'https://tmss.preprod-acqit.helix.gsa.gov/tmssserver/login',
  // redirectUri: 'https://tmss-dev.gsa.gov/tmssserver/login',
  oktaClientId: '0oa2g7l5mpCGLCadD297',
};
